import { render, staticRenderFns } from "./CargoPickupPage.vue?vue&type=template&id=aad4ff0c&scoped=true&"
import script from "./CargoPickupPage.vue?vue&type=script&lang=js&"
export * from "./CargoPickupPage.vue?vue&type=script&lang=js&"
import style0 from "./CargoPickupPage.vue?vue&type=style&index=0&id=aad4ff0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aad4ff0c",
  null
  
)

export default component.exports